// extracted by mini-css-extract-plugin
export default {"root":"App_root__rOKlB","navbar":"App_navbar__iaZY8","content":"App_content__Ys+Z8","footer":"App_footer__TWPrC"};